import _styled from "@emotion/styled-base";
import { Box } from '../Flexbox';

var Panel = /*#__PURE__*/_styled(Box, {
  target: "en1xqt80"
})("border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors['ui-border'];
}, ";border-radius:0.25rem;padding:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[5];
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9QYW5lbC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTBDIiwiZmlsZSI6Ii4uLy4uL3NyYy9QYW5lbC9zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IENvZGFjeVRoZW1lIH0gZnJvbSAnLi4vdGhlbWUnXG5pbXBvcnQgeyBCb3ggfSBmcm9tICcuLi9GbGV4Ym94J1xuXG5jb25zdCBQYW5lbCA9IHN0eWxlZChCb3gpPHt9LCBDb2RhY3lUaGVtZT5gXG4gIGJvcmRlcjogMXB4IHNvbGlkICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzWyd1aS1ib3JkZXInXX07XG4gIGJvcmRlci1yYWRpdXM6IDAuMjVyZW07XG4gIHBhZGRpbmc6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuc3BhY2VbNV19O1xuYFxuXG5leHBvcnQgeyBQYW5lbCB9XG4iXX0= */"));

export { Panel };